var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Conversion1Widget',{attrs:{"main_icon":_vm.main_icon,"load_url":_vm.load_url,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }